import React from 'react';
import {useTranslation} from 'react-i18next';
import Checkbox from '../../common/component/form/Checkbox';

function FilterPopup({
                         options,
                         values,
                         onChange,
                         selectAllOptions,
                         deselectAllOptions,
                         isMulti = true,
                         infoText
                     }) {

    const [t] = useTranslation();

    function onChangeSelectAll() {
        if (values.some(val => !val.show)) {
            selectAllOptions && selectAllOptions();
        } else {
            deselectAllOptions && deselectAllOptions();
        }
    }

    return (
        <>
            <form>
                {
                    infoText &&
                    <div className="ml-3 mb-2 mt-2">{infoText}</div>
                }
                {
                    isMulti &&
                    <div key={options.length} className="form-check">
                        <Checkbox
                            key={options.length}
                            id={options.length}
                            onChange={onChangeSelectAll}
                            value={values.every(val => val.show)}
                            readonly={false}
                            label={t('Button.SELECT_ALL')}
                        />
                    </div>
                }

                {
                    options.map((entry, idx) => {
                        return (
                            <div key={`${idx}`} className="form-check">
                                <Checkbox
                                    key={entry.value}
                                    id={idx}
                                    onChange={onChange}
                                    value={(idx < values.length) ? values[idx].show : false}
                                    readonly={false}
                                    label={entry.label}
                                />
                            </div>
                        );
                    })
                }
            </form>
        </>
    );
}

export default FilterPopup;
